import React from "react";
import SensitivityCase from "../SensitivyCase";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import MultiCase from "../MultiCase";
import FirstPrinciples from "../FirstPrinciples";
import SelexOnline from "../SelexOnline";
import { baseURL } from "../../Config/config";
import {Paper,Typography} from "@mui/material";


export default function AllDeploy(props) {
  const [value, setValue] = React.useState("2");
  const [timeseries, setTimeseries] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    getTimeseries();
  }, []);

  const getTimeseries = () => {
    const projectID = sessionStorage.getItem("projectID");
    fetch(`${baseURL}/getTimeseries?projectID=${projectID}`)
      .then((res) => res.json())
      .then((data) => {
        setTimeseries(data.timeseries);
        console.log(data.timeseries);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const tabStyle = {
  textTransform: "none",
  fontSize: "12px",
  minHeight: 40,
  fontWeight: 500,
  borderRadius: "12px",
  color: "#444",
  transition: ".3s",
  px: 3,

  "&.Mui-selected": {
    color: "#fff",
    background: "linear-gradient(90deg,#0078c9,#0d8fe6)",
    boxShadow: "0px 8px 18px rgba(0,120,201,.25)",
  },
};

 return (
  <Box sx={{ px: 2, py: 2, mt: 3 }}>
    <Paper
      elevation={0}
      sx={{
        borderRadius: "22px",
        p: 2,
        bgcolor: "#fff",
        borderColor:"#0078c9",
        boxShadow: "0px 8px 30px rgba(0,0,0,.06)",
      }}
    >
      <TabContext value={value}>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <TabList
            onChange={handleChange}
            TabIndicatorProps={{ style: { display: "none" } }}
            sx={{
              bgcolor: "#f8fafc",
              borderRadius: "16px",
              p: 0.7,
              minHeight: "auto",
              "& .MuiTabs-flexContainer": {
                gap: 1,
              },
            }}
          >
            {!timeseries && (
              <Tab label="First Principles" value="1" sx={tabStyle} />
            )}

            <Tab label="Sensitivity Case" value="2" sx={tabStyle} />
            <Tab label="Multi Case" value="3" sx={tabStyle} />

            {!timeseries && (
              <Tab label="SelexOnline" value="4" sx={tabStyle} />
            )}
          </TabList>
        </Box>

        <Box
          sx={{
            mt: 2,
            p: 2,
            borderRadius: "18px",
            bgcolor: "#fff",
            minHeight: "500px",
            boxShadow: "0px 4px 18px rgba(0,0,0,.04)",
          }}
        >
          {!timeseries && (
            <TabPanel value="1" sx={{ p: 0 }}>
              <FirstPrinciples
                editAccess={props.editAccess}
                loaded={props.loaded}
                ProjectID={props.ProjectID}
              />
            </TabPanel>
          )}

          <TabPanel value="2" sx={{ p: 0 }}>
            <SensitivityCase
              editAccess={props.editAccess}
              loaded={props.loaded}
              ProjectID={props.ProjectID}
            />
          </TabPanel>

          <TabPanel value="3" sx={{ p: 0 }}>
            <MultiCase
              editAccess={props.editAccess}
              loaded={props.loaded}
              ProjectID={props.ProjectID}
            />
          </TabPanel>

          {!timeseries && (
            <TabPanel value="4" sx={{ p: 0 }}>
              <SelexOnline
                editAccess={props.editAccess}
                loaded={props.loaded}
                ProjectID={props.ProjectID}
              />
            </TabPanel>
          )}
        </Box>
      </TabContext>
    </Paper>
  </Box>
);
}
